export default __webpack_public_path__ + "static/media/vincennes11.f6f389b1.jpg";